export const environment = {
  production: true,
  apiUrl: 'https://thinksites.com.br/api/fit-up-modern?populate=deep',
  imageSEO: 'https://fitupxp.web.app/assets/images/logo/Logo-Fit-Up-Quadrado.png'
};
